import React from 'react';
import LegalLayout from './LegalLayout';

/**
 * AGB / Allgemeine Geschäftsbedingungen for Real Content.
 *
 * Adapted from REALTECHSOLUTIONS' standard product terms (used on other
 * services in the same legal framework). Key clauses preserved as-is:
 * Spanish jurisdiction, Las Palmas / Fuerteventura courts, language of
 * record is Spanish (per existing corporate template). The German
 * version on this page is the customer-facing translation.
 */
export default function AGBPage() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen">
      <p>
        <strong>Stand:</strong> 29. April 2026
      </p>

      <p>
        Diese AGB regeln die Nutzung der Plattform <strong>Real Content</strong>,
        einem Produkt der REALTECHSOLUTIONS, S.L. (im Folgenden „der
        Anbieter"). Mit dem Zugriff auf und der Nutzung der Plattform
        erklären Sie sich mit diesen Bedingungen einverstanden.
      </p>

      <h2>1. Unternehmensinformationen</h2>
      <p>
        Firmenname: REALTECHSOLUTIONS, S.L.<br />
        Handelsname: Real Content<br />
        Geschäftssitz: Calle Galicia, Num 9, Bloque B, Planta Baja, Puerta 3, 35660 Corralejo, La Oliva, Fuerteventura, Las Palmas, Spanien<br />
        Eingetragen im Handelsregister von Las Palmas<br />
        CIF: B16358327
      </p>

      <h2>2. Geltungsbereich und Akzeptanz</h2>
      <p>
        Mit dem Zugriff auf oder der Nutzung dieser Plattform erklären
        Sie sich bereit, diese AGB sowie alle zusätzlichen Richtlinien
        oder zukünftigen Änderungen einzuhalten. Wenn Sie nicht
        einverstanden sind, müssen Sie die Nutzung der Plattform
        einstellen.
      </p>

      <h2>3. Änderung der Bedingungen</h2>
      <p>
        Der Anbieter behält sich das Recht vor, diese Bedingungen
        jederzeit zu ändern oder zu aktualisieren. Wesentliche Änderungen
        teilen wir Ihnen per E-Mail mit. Die fortgesetzte Nutzung der
        Plattform nach einer solchen Mitteilung gilt als Akzeptanz der
        geänderten Bedingungen.
      </p>

      <h2>4. Berechtigung</h2>
      <p>
        Die Plattform steht ausschließlich Personen ab 18 Jahren zur
        Verfügung. Mit der Nutzung erklären Sie, dass Sie diese
        Altersanforderung erfüllen.
      </p>

      <h2>5. Leistungsumfang</h2>
      <p>
        Real Content stellt eine SaaS-Plattform zur automatisierten
        Erstellung und Veröffentlichung von Immobilien-Videos auf
        sozialen Netzwerken zur Verfügung. Der konkrete Funktionsumfang
        ergibt sich aus dem gewählten Tarif (Free / Pro). Der Anbieter
        behält sich vor, einzelne Funktionen zu erweitern, zu ersetzen
        oder einzustellen, soweit dies dem Kunden zumutbar ist.
      </p>

      <h2>6. Bezahlte Pläne und Zahlungsbedingungen</h2>
      <ul>
        <li>Bezahlte Abonnements bieten Zugang zu erweiterten Funktionen,
          unbegrenzten Renderings und höherwertigen Templates.</li>
        <li>Zahlungen werden über Stripe abgewickelt. Abonnements werden
          monatlich oder jährlich abgerechnet, je nach Auswahl.</li>
        <li>Nichtzahlung kann zur Aussetzung oder Beendigung der
          Dienstleistung führen.</li>
      </ul>

      <h2>7. Free-Tier und Verifizierung</h2>
      <p>
        Der kostenlose Tarif beinhaltet eine begrenzte Anzahl monatlicher
        Renderings. Zur Vermeidung von Missbrauch erfordert die Nutzung
        des Free-Tier eine bestätigte E-Mail-Adresse sowie eine
        hinterlegte Kreditkarte (€0-Verifizierung über Stripe; es wird
        nichts abgebucht). Die Karte wird ausschließlich verwendet, um
        die Echtheit des Accounts zu verifizieren und im Missbrauchsfall
        eine geringfügige Verifizierungsgebühr abrechnen zu können.
      </p>

      <h2>8. Kündigungs- und Rückerstattungspolitik</h2>
      <p>
        Sie können Ihr Abonnement jederzeit über das Stripe Customer
        Portal (verlinkt im Bereich „Abrechnung verwalten") oder per
        E-Mail an uns kündigen. Nach der Kündigung behalten Sie den
        Zugang bis zum Ende des bezahlten Zeitraums. Rückerstattungen
        für nicht genutzte Teile eines Abonnementzeitraums werden nicht
        gewährt, außer wo gesetzlich vorgeschrieben.
      </p>

      <h2>9. Geistiges Eigentum</h2>
      <p>
        Alle Inhalte der Plattform, einschließlich Texte, Bilder,
        Grafiken, Logos, Designs und Software, sind Eigentum von
        REALTECHSOLUTIONS, S.L. oder deren Lizenzgebern. Die
        unautorisierte Nutzung, Vervielfältigung oder Verteilung von
        Material ohne vorherige schriftliche Genehmigung ist untersagt.
      </p>
      <p>
        Inhalte, die Sie über die Plattform hochladen oder generieren
        (z. B. Ihre Immobilien-Videos), bleiben Ihr Eigentum bzw. das
        Eigentum der von Ihnen bevollmächtigten Rechteinhaber. Sie
        räumen dem Anbieter eine nicht-exklusive, weltweite Lizenz
        ein, diese Inhalte ausschließlich zur Bereitstellung der
        Dienstleistung (Verarbeitung, Speicherung, Veröffentlichung
        nach Ihrer Anweisung) zu verwenden.
      </p>

      <h2>10. Pflichten des Kunden</h2>
      <p>
        Sie verpflichten sich:
      </p>
      <ul>
        <li>ausschließlich Immobilieninserate zu posten, deren
          Vermarktung Ihnen obliegt (z. B. als Makler:in);</li>
        <li>keine automatisierten Tools (Bots, Scraper) zu verwenden,
          um auf die Plattform zuzugreifen oder Daten zu extrahieren,
          außer im Rahmen der zugelassenen API-Nutzung;</li>
        <li>die Plattform nicht zur Verbreitung rechtswidriger,
          irreführender oder beleidigender Inhalte zu nutzen;</li>
        <li>die Vertraulichkeit Ihrer Zugangsdaten zu wahren. Der
          Anbieter haftet nicht für Schäden, die aus der Nichteinhaltung
          dieser Pflicht entstehen.</li>
      </ul>

      <h2>11. Sicherheitsmaßnahmen</h2>
      <p>
        Der Anbieter implementiert angemessene technische und
        organisatorische Maßnahmen zum Schutz der Benutzerdaten. TLS-
        Verschlüsselung in Transit, Server-Hosting in Rechenzentren
        innerhalb der EU, regelmäßige Sicherheitsüberprüfungen.
      </p>

      <h2>12. Haftungsausschluss zu Inhalten</h2>
      <p>
        Die von der Plattform bereitgestellten Daten und KI-generierten
        Inhalte (z. B. Texte, Voiceovers) dienen ausschließlich der
        Vermarktungsunterstützung. Wir übernehmen keine Garantie für
        ihre Genauigkeit, Vollständigkeit oder rechtliche Korrektheit.
        Sie sind als Kunde dafür verantwortlich, die Inhalte vor der
        Veröffentlichung zu prüfen. Die Vorschau-Funktion 12 Stunden vor
        Veröffentlichung dient genau diesem Zweck.
      </p>

      <h2>13. Haftung</h2>
      <p>
        Der Anbieter haftet bei Vorsatz und grober Fahrlässigkeit
        unbeschränkt. Bei leichter Fahrlässigkeit ist die Haftung auf
        vorhersehbare, vertragstypische Schäden begrenzt. Die Haftung
        für entgangenen Gewinn ist ausgeschlossen.
      </p>

      <h2>14. Beta-Funktionen</h2>
      <p>
        Gelegentlich bieten wir neue Funktionen in einer Beta-Phase an.
        Diese werden „wie besehen" und „nach Verfügbarkeit"
        bereitgestellt und können Fehler oder Mängel enthalten. Wir
        garantieren weder Leistung noch Funktionalität dieser
        Beta-Funktionen.
      </p>

      <h2>15. Kontoschließung durch den Anbieter</h2>
      <p>
        Der Anbieter behält sich das Recht vor, jedes Benutzerkonto zum
        Ende des bezahlten Zeitraums plus 30 Tage Karenzzeit zu
        schließen, falls wesentliche Verstöße gegen diese AGB vorliegen.
      </p>

      <h2>16. Beschwerden und rechtliche Anfragen</h2>
      <p>
        Anfragen zur Kündigung oder Vertragsänderung können per E-Mail
        an{' '}
        <a href="mailto:info@real-content.at">info@real-content.at</a>{' '}
        gerichtet werden. Formelle rechtliche Anfragen (z. B.
        Unterlassungsaufforderungen) müssen schriftlich per
        eingeschriebener Post an unsere registrierte Geschäftsadresse
        gesendet werden; per E-Mail werden diese nicht akzeptiert.
      </p>
      <p>
        Datenschutz-Beschwerden können bei der spanischen{' '}
        <a href="https://www.aepd.es" target="_blank" rel="noreferrer noopener">
          Agencia Española de Protección de Datos (AEPD)
        </a>
        {' '}oder bei der österreichischen{' '}
        <a href="https://www.dsb.gv.at" target="_blank" rel="noreferrer noopener">
          Datenschutzbehörde
        </a>{' '}
        eingereicht werden.
      </p>

      <h2>17. Anwendbares Recht und Gerichtsstand</h2>
      <p>
        Diese AGB unterliegen den Gesetzen Spaniens. Alle Streitigkeiten
        werden ausschließlich vor den Gerichten von Puerto del Rosario,
        Fuerteventura, entschieden, soweit nicht zwingende
        verbraucherschützende Gerichtsstände im Wohnsitzland des
        Verbrauchers etwas anderes vorschreiben.
      </p>
      <p>
        Geltende Sprache dieser Bedingungen und aller damit verbundenen
        Dokumente ist Spanisch. Die deutsche Fassung dient der
        Information; im Falle von Auslegungsunterschieden hat die
        spanische Originalfassung Vorrang.
      </p>

      <h2>18. Alternative Streitbeilegung</h2>
      <p>
        Bevor formelle rechtliche Verfahren eingeleitet werden, stimmen
        die Benutzer zu, zuerst zu versuchen, Streitigkeiten durch
        informelle Verhandlungen mit dem Anbieter beizulegen.
      </p>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer noopener">
          https://ec.europa.eu/consumers/odr
        </a>.
      </p>

      <h2>19. Salvatorische Klausel</h2>
      <p>
        Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise
        unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen
        Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung
        tritt eine Regelung, die dem wirtschaftlichen Zweck der
        ursprünglichen Bestimmung am nächsten kommt.
      </p>
    </LegalLayout>
  );
}
